import { Card, CardActionArea, CardContent, CardMedia, Grid, Typography, Box, CircularProgress } from "@mui/material"
import { useSelector } from "react-redux"
import { Link } from "react-router-dom"
import styled from "styled-components"
import CircularProgressBox from "../CircularProgressBox"
import './VideoGrid.css'

export default function VideoGrid(props){
    const videos = useSelector(state => state.videos)
    // console.log(videos)

    if(!videos.length) return (
        <CircularProgressBox/>
      );

    return (
        <Box className="video-grid">
            <Grid 
                container 
                rowSpacing={2} 
                columnSpacing={2} 
                sx={{
                    position: "relative",
                    margin: "1.5rem auto",
                    height: "50%"
                }}
            >
                {
                    videos.map((video, i) => (
                        <Grid item xs={12} sm={6} md={3} key={i} padding='0 22px' margin='0'>
                            <Link to={`/${video._id}`} className="video-tile-link">
                            <Card 
                            className="video-tile"
                            sx={{ 
                                maxWidth: 345, 
                                maxHeight: 212, 
                                margin: "0 auto", 
                                height: "100%",
                                }}
                            >
                                <CardActionArea>
                                    <CardMedia
                                        component="img"
                                        height="140"
                                        image={video.previewImage}
                                        alt={video.title}
                                    />
                                    <CardContent sx={{padding: 0.5, bgcolor:"#121212", color: "#fff", display: 'flex', flexDirection:'column', justifyContent: 'space-around', alignItems:"start"}}  align="left">
                                        <Typography gutterBottom variant="body1" className='video-title'>
                                            {video.title}
                                        </Typography>
                                        <br/>
                                        <Typography variant="body3" color="#aeaeae" className='video-release-date'>
                                            {video.releaseDate}
                                        </Typography>
                                    </CardContent>
                                </CardActionArea>
                            </Card>
                            </Link>
                        </Grid>
                    ))
                }
            </Grid>
        </Box>
    )
}